// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"98f3a683","423":"0bd44a2c","453":"fe335312","575":"fbe28e33","850":"0544176a"}[chunkId] + ".chunk.css";
};